<button *ngIf="ready && !ttSkeleton" class="tt-tabs__button" (click)="onClick($event)" [ngClass]="{ 'tt-tabs__button--active': ttActive }" [disabled]="ttDisabled">
    <span *ngIf="!!ttIcon" class="fa-fw" [ngClass]="ttIcon"></span>
    <span class="tt-tabs__text">{{ label }}</span>
    <ng-content></ng-content>
    <span *ngIf="ttDismissable && parentDismissable" class="fa-fw fal fa-times" (click)="dismiss($event)"></span>
</button>
<div *ngIf="!ready || ttSkeleton" class="tt-skeleton tt-skeleton--tab">&nbsp;</div>
